<script setup>
import { ref } from 'vue';
import { useI18n } from 'vue-i18n';

import LayoutValidation from '@layouts/LayoutValidation.vue';
import AccessTermResult from '@views/AccessTermResult.vue';
import BaseFileUpload from '@components/base/BaseFileUpload.vue';
import { XLink } from '@clicksign/excalibur';

defineProps({
  parentUrl: {
    type: String,
    default: window.location.origin,
  },
});

const { t } = useI18n();

const isDocumentValid = ref(false);

function validDocument(result) {
  isDocumentValid.value = result;
}
</script>

<template>
  <LayoutValidation
    icon="file-certificate"
    :show-result="isDocumentValid"
    color="var(--color-feedback-info-400)"
    container-width="100%"
  >
    <template #title>
      {{ t('validateAccess.title') }}
    </template>

    <template #description>
      <p>
        {{ t('validateAccess.description') }}
      </p>
      <p>
        {{ t('validateAccess.help') }}
        <XLink
          no-padding
          :to="t('validateAccess.contactLink')"
        >
          {{ t('validateAccess.contact') }}
        </XLink>
      </p>
    </template>

    <template #action>
      <BaseFileUpload
        :path="'/validate_accesses.json'"
        :loading-text="t('validator.document.loading')"
        @document-validated="validDocument"
      />
    </template>

    <template #result>
      <AccessTermResult :parent-url="parentUrl" />
    </template>
  </LayoutValidation>
</template>

<style lang="scss" module></style>
